// Same i18n setup as frontend/src/i18n/index.ts, cloud storage key.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import de from "./locales/de.json";
import sl from "./locales/sl.json";
import { FINANCE_VARS } from "../config/finance";

export const supportedLanguages = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "sl", label: "Slovenščina" },
] as const;

export type LanguageCode = typeof supportedLanguages[number]["code"];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      sl: { translation: sl },
    },
    fallbackLng: "en",
    supportedLngs: supportedLanguages.map((l) => l.code),
    interpolation: {
      escapeValue: false,
      // Money figures quoted in the landing copy come from
      // config/finance.json, not from the locale files — one number, one
      // place, instead of the same amount typed into three translations.
      // Supplied as defaults so no call site has to pass them.
      defaultVariables: FINANCE_VARS,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "icc.lang",
    },
  });

export default i18n;
